import { render, staticRenderFns } from "./ItemDetailInfoLayout.vue?vue&type=template&id=174228fc&scoped=true"
import script from "./ItemDetailInfoLayout.vue?vue&type=script&lang=js"
export * from "./ItemDetailInfoLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "174228fc",
  null
  
)

export default component.exports